import { Pipe, PipeTransform } from '@angular/core';
import {TransactionDescriptionBuilder} from './transaction-rule-descriptionn-builder';

@Pipe({
  name: 'transactionProfile',
  pure: true // only run when inputs change
})
export class TransactionProfilePipe implements PipeTransform {
  transform(rule: any): string {
    return  this.buildTransactionProfileDescription(rule);
  }

  public buildTransactionProfileDescription(rule: any): string {
    if (!rule || (rule && !rule.transactionRule)) {
      return '';
    }

    if (!rule.transactionRule.name) {
      return '';
    }

    try {
      return new TransactionDescriptionBuilder(rule.transactionRule.name)
        .addCashFlow(rule.transactionRule.cashFlowName)
        .addAmountRange(rule.transactionRule.amountFrom, rule.transactionRule.amountTo)
        .addFrequency(rule.transactionRule.frequency, rule.transactionRule.frequencyPeriodName)
        .addMaxAmount(rule.transactionRule.maxAmount, rule.transactionRule.maxAmountPeriodName)
        .build();
    } catch (error) {
      console.error('Error building transaction description:', error);
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/transaction-rule/transaction-profile-description.pipe.ts